//<editor-fold defaultstate="collapsed" desc="interface IDBResponse">
export interface IDBResponse {
    tipo: EDBResponseType, 
    data: string | number | Object[];
}
//</editor-fold>

//<editor-fold defaultstate="collapsed" desc="enum EResponseType">
export enum EDBResponseType {    
    CONN_ERR,
    CONN_OK,
    AUTH_OK,
    AUTH_ERR,    
    QUERY_ERR,
    QUERY_OK,
    ERR,
    OK
}
//</editor-fold>


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./common/responses.ts